/**
 * All the actions for all the context are to be declared here.
 * We want to make sure that they are unique even if context is not.
 */

export const SET_APP_DATA = 'SET_APP_DATA';
export const SET_APPLICATION_NAME = 'SET_APPLICATION_NAME';
export const SET_MSAL_CONFIG_DATA = 'SET_MSAL_CONFIG_DATA';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const ADMIN_USER = 'ADMIN_USER';

export const SET_MODULE_DATA = 'SET_MODULE_DATA';
export const SET_SUBMODULE_DATA = 'SET_SUBMODULE_DATA';

export const SET_SELECTION_DATA = 'SET_SELECTION_DATA';

export const SET_DOCUMENT_SELECTION_DATA = 'SET_DOCUMENT_SELECTION_DATA';
export const REMOVE_DOCUMENT_SELECTION_DATA = 'REMOVE_DOCUMENT_SELECTION_DATA';
export const CLEAR_DOCUMENT_SELECTION_DATA = 'CLEAR_DOCUMENT_SELECTION_DATA';

export const SET_DICOM_SELECTION_DATA = 'SET_DICOM_SELECTION_DATA';
export const REMOVE_DICOM_SELECTION_DATA = 'REMOVE_DICOM_SELECTION_DATA';
export const CLEAR_DICOM_SELECTION_DATA = 'CLEAR_DICOM_SELECTION_DATA';

export const SET_ISBH_DATA = 'SET_ISBH_DATA';
export const SET_ISBH_REASON_DATA = 'SET_ISBH_REASON_DATA';
